import { render, staticRenderFns } from "./SideBarComponent.vue?vue&type=template&id=e0480e6a&scoped=true&"
import script from "./SideBarComponent.vue?vue&type=script&lang=ts&"
export * from "./SideBarComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarComponent.vue?vue&type=style&index=0&id=e0480e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0480e6a",
  null
  
)

export default component.exports